import { ModeSelector } from "@/components/ModeSelector";
import { LocationConfigurationProvider } from "@/providers/LocationConfigurationProvider";
import { LocationContextProvider } from "@/providers/LocationContextProvider";
import { ThemeProvider } from "@/providers/ThemeProvider";
import { Outlet } from "@tanstack/react-router";

export function LocationLayout() {
  return (
    <LocationContextProvider>
      <LocationConfigurationProvider>
        <ModeSelector />
        <ThemeProvider />
        <Outlet />
      </LocationConfigurationProvider>
    </LocationContextProvider>
  );
}
